exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".tab-shadow {\n    position: absolute;\n    top: 0;\n    left: 0;\n\n    width: 100%;\n    height: 51px;\n\n    border: 0;\n    -webkit-box-shadow: 0 4px 6px rgba(0, 0, 0, 0.2);\n            box-shadow: 0 4px 6px rgba(0, 0, 0, 0.2);\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"importLoaders":1}!./~/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/components/ui/hr.css
// module id = ./node_modules/css-loader/index.js?{"importLoaders":1}!./node_modules/postcss-loader/lib/index.js?{"ident":"postcss","plugins":[null,null]}!./src/components/ui/hr.css
// module chunks = 0